import { DrawableObject } from "./DrawableObject";
import { WorldObjectType } from "../../api";
export class LabelCollectionObject extends DrawableObject {
    constructor(labelCollection, objectId) {
        super(labelCollection);
        this.object = labelCollection;
        this.id = objectId;
    }
    get labels() {
        return this.object.labels;
    }
    get maxLabelNum() {
        return this.object.maxLabelNum;
    }
    get needsRebuild() {
        return this.object.needsUpdate;
    }
    invalidateCaches() {
        this.object.needsUpdate = true;
    }
    forceRebuild() {
        this.object.prepare();
    }
    getObjectType() {
        return WorldObjectType.LabelCollection;
    }
    get isTransparent() {
        return true;
    }
}
